
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexytOGmLiS2w41Y_45z97NrFoI_L92R8c3u_wyB7tXAKm6YMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/index.vue?macro=true";
import { default as loginNiQnUUi32kog2_45rSlv6RRG17qcXBjgSHoHFT9ijUgvUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/login.vue?macro=true";
import { default as mgenws1gqIqjlr_453HHuN7NLbX0yENRN8ttHIJ_45UDoQXjQ5gMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/mgen.vue?macro=true";
import { default as indexO3pIT9kk2ZbgXAF6xMyl6142zefiQV_9Ods3kbNC5MwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/index.vue?macro=true";
import { default as notesRjs7zKpO_UQNw5FHaE1JpQsoTUd73M_45KmKbez0VhUigMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/notes.vue?macro=true";
import { default as indexOzwLnIG4ZJ_451ashymhkoxa_rPQh7_45T7a20_45sbcXEj3sMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentbaf_RDnc91_45upwrbsxNnDsMeNS5H2K_LxEPmRPeuvXwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteXQvtQpGqFC6pc_451vycciYWcdAazBC_UkRDvTige2l8UMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/plan-du-site.vue?macro=true";
import { default as editCEriP5sUDOIVdmH90q7CxJ6vIizJMcQuPPUmDgmMGu0Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/edit.vue?macro=true";
import { default as placesLe8A482As8fn5uUjhUuizY74pi4zE47GdVMUkhsAsFsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/places.vue?macro=true";
import { default as accessibilitey7_45TDRDnlcZ534GmKZPkYGHevHLG5BL9sQBqu4hf3qAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/accessibilite.vue?macro=true";
import { default as _91id_93_RIjI_3B_45RArEnQ9MZZPj0UD2i_45Vxy2m_82gp5iw6n4Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/[id].vue?macro=true";
import { default as notificationspJANcxSrA_45yGT90AYT6mSQuIchVwy9an47XRQXcdzfAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/notifications.vue?macro=true";
import { default as indexBzkh6Z4IHWML32fgQdhkbT65VBNsNCnqgG6ZI7wqpzoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/index.vue?macro=true";
import { default as index5UyrufiC_45RD4kQHBPGRpSH_45M6XJCteMHDkkhPdAUrKwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/index.vue?macro=true";
import { default as _91slug_934LXi_IjqDoewnR3tceyDumksQu6t0fka7eW_rjoOsJYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/villes/[slug].vue?macro=true";
import { default as indexBO3OT0KLZZwYm26Boz2UxNQ9w560q77mUGrtPLqJ8aUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/index.vue?macro=true";
import { default as generiquebEOiBqXJnIRYwdsl1ZDSGe1_45G_45bFIdd894K_Oy_NYGAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93pXz39zPancpfVVqK6dIFDMe6QetGzzSg1nkQOzyeO_UMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/reseaux/[slug].vue?macro=true";
import { default as missionsJCEHVXxZ24aE1L00liSe6J46fKtt6QjH43CK2VKCc8AMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/missions.vue?macro=true";
import { default as indexiTx_c8p87Y5Ivo5WNptWA_45mZHhDi2UXYMdx6g8iBTmgMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/dashboard/index.vue?macro=true";
import { default as favorisHtR7tIXHioIGSetHz2wCL7WyUgU_ry6bm8lcfoeRyaAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93bAITO_irYGKHNg59YxrvVU8zilFfqcXRENPrNpW0mJ8Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/activites/[slug].vue?macro=true";
import { default as logsfXLqCT6AgfQH5X3hB8BsT8kdHPiir6wgz0hCDZks8M8Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesiBsWeaTo26SQnKa5dXTzOYBDJnuHqShgaxXPSqHtd9cMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legales7_tE0BzPazgX0IKd08l5gn_Qlxg41BylfKZWBcI9_45CUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/mentions-legales.vue?macro=true";
import { default as missions2kf1683lBg2VKb0SxSS3_i3WEIiBd8WG_s2bQBdLAxAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/missions.vue?macro=true";
import { default as settingswTtp5h8Vm1Y9CziEkwrhDZ7j5pAGYdxf1InfUUpmNdkMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/settings.vue?macro=true";
import { default as temoignagesoznSYWeqg9slTaMHCL0QpUcvMlDTCjYyGnr75KWJvZMMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/temoignages.vue?macro=true";
import { default as indexONo3lZ6I4f4zjbw5JY9Pz11xza3RVmZATHkIo7w82hwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/index.vue?macro=true";
import { default as adminl5z7d_45jBvL7_M3j7n3rfSNugiIL19c8NvRjgd8_45f5qoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/maintenance/admin.vue?macro=true";
import { default as indexiAdfVKYqSCaAYSCZ7kfRFhHD2ee51_45F6io0YeZsKnQsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/maintenance/index.vue?macro=true";
import { default as indexphOsQMeOwVOQG4arndDSzCoUYpE9CjdU7KwFxx6pMiEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/territoires/index.vue?macro=true";
import { default as _91hash_93VyegDZ7nurlcJh1FV9HDqADKdIjS6HNpT5Ux3eubzM4Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursE8SgTHYZZ81OBePpPT6W56SB0Nzjgf1B2k8GdCBAgPYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93i9B0ubWHju6u9bBtLBvzVZvAtjeRlW8A_knOLWYtyZ8Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/associations/[slug].vue?macro=true";
import { default as _91slug_933mStDpJ0dBLvFVXRKEw7QIdfbP1OwyI_wVMGQyEq1EMMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/departements/[slug].vue?macro=true";
import { default as indexMUHwlw8kp6itU1XWbxLkiba1MF30mpLoJtNsH71P9jsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/organisations/index.vue?macro=true";
import { default as preferenceslG12dVraHHIatRweawwHdk4o0LlCNjjEzaJJqDPXgxoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/preferences.vue?macro=true";
import { default as organisationsVTDwWKOCvPLpnksLsq_456_RxhD_45GS4WQnHe_451_45uy3U2oMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/organisations.vue?macro=true";
import { default as _91token_93twZPslVQ2c9WXRgf9klzL9APxzmK5_45ZsINfZ3z2SWnIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/temoignages/[token].vue?macro=true";
import { default as postsRE3UIwN3hlvvHJ1W9WgTsBfqPQZYi0bHFHmNQYKD5QUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/posts.vue?macro=true";
import { default as index_45wk4BgrBgqkMWuw8PevfBvTAk4_45o0m9D54mPpEM0b5cMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/index.vue?macro=true";
import { default as addnyS9OkUIjIt93pX6elTDkKRNvZjwN_45JMCzktJmuJ5NUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93lo7spXAc_UgJHoUPC3P_CMda9YMKga7uKffZuHA_iFIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/organisations/[slug].vue?macro=true";
import { default as indexoeeMDp7Xc9ym0l335lrSAkT9tPWGW2nnJkx50N__BpgMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/password-reset/index.vue?macro=true";
import { default as participations5zO4t9VQKmV2QLzrCSB4Y3y_45Ihpsz6lVPCzQ8cL54IYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/participations.vue?macro=true";
import { default as emailsz52aTFN3_bJrdl55qVqtnDovsEIl2s0cgN6EQdi96vAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/emails.vue?macro=true";
import { default as indexCU7EY0I5eqG36pBfskT8lKfxhZISkJkTKVIkPipzjnsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/alertes/index.vue?macro=true";
import { default as notifications9mbMmfPm8tTsmY64_5kk08ycr0T60mgEdTlGwVdix_IMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/notifications.vue?macro=true";
import { default as indexyyVS5wwLTIvusgumKgrShRu9tLLxZ0NdU7_VoYf4Ei0Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiquep_45T9hSI8Ah88EmVjkl6HI_cciNth6u4aAr2lVv3hWAUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93wvniSvbDTifvxX3_VyMJzj9GpIb6W5g4BTPIKHwHsP0Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/domaines-action/[slug].vue?macro=true";
import { default as indexyHwJpxKB5GciFMbVWVez_458JvW6HDpYAaADYJ6xzyfJkMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93SXq35Qw09Uoo6ykX1Uhp2g_whfxyTfvV3cXqluZcEcEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembleJfRJwBb70Bba7cUb4XRS25Fv6UR0BdWlzvK9xw_45j9xQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationshWr3lI3tdDIJ4hkPelcP50gUSTf3b00Iw0hBKZo0vlIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/other/invitations.vue?macro=true";
import { default as messagescQdvu37G5bghdkULNwW4daAgK4KNWfkf0zsUhTAK6qYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/messages.vue?macro=true";
import { default as placesGi9STZIPh86yABxBbVAOKpRVU_451iLFb0KmB3wFZ7w40Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/places.vue?macro=true";
import { default as addyxAn9Q6UrzkXolZPivDpBbyqbDu2UoSOeZrcqH_HufAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexOMo8BHV4BilX2exQ2qkXJwjqx9UAdk0T0zASO4UDQZUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexrcx6UOcI6cIm7eFTIVrxH3qT6i_45_SzLcMMx8jzL00DIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/missions-benevolat/index.vue?macro=true";
import { default as dates4w_6gqgVGL_45zB9BvEe1ccj_hs_45sc116Qbg8ZJoaq55MMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as index__AsYZvxWjccApYVsWTRX8alTteVBBj4a36Vge98094Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieux0dmHEc3lK4BAI3PT_6tCw9zwHBJJNJAvRQHh_53fPRoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleF52pV3wx05RTzvNZpqMKJCXQIrw_o9BNXkRqE0HqaIkMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexV6cb85zFnmBIYNhNbSnl4uh_45SvOFk9JfbxTHcSJ4uqgMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/index.vue?macro=true";
import { default as missionsqkcjNy5Ae9aZ6z360B4_45WStiChq1G9c8y3H_453hpmsmYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/missions.vue?macro=true";
import { default as add0I_g_XJS8XfnnngwzYu5E9Ay1xXsJGE0E29sF5J3rAAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelJuUuFC0jiRbp7_hY3aOD68QgiiK84msUOIwNoskHXxEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexIZfTBBHqx2O2BYtj0g3IWULuSjfeXBaqYJIfPi8XNfwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/participations/index.vue?macro=true";
import { default as index9LXJW_KmovtSvygdzNRhRmPc9XsT6tihhL1CE6zPcqEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexRdcUjqosPHe8TYHQjDzV5p63ycwkVjfdwkl2xl70uJgMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/index.vue?macro=true";
import { default as addmwUDxlRQ6fwR1cCAEVAp79l6P_K90DBBWRESd2VESW4Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as add3LtBO2ij57s_obVzkTDqd_2_7ppk2DUWDAhnXX3sy5EMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addCjnN9c4j8Dus6r1NC1B4tVHvx60a8_45x5l8IXCUZs8twMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexR9Nx4pHGovhShX2d0RXwlVEyjA_djiraYEJNns1mJwwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionslMKgmzXnjAH1wbfdMWZ5Dl_45GmgqjuAArAXtFJnIWpw0Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/conversions.vue?macro=true";
import { default as edit1Tvja_45JOVpyf8rFCL4SK_457wHtKXRTRYLqkoTJKiC0noMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteBPekeJFfHlYJ_45kiGgUyn6o8OgFBjv48SAaWET6kOYY8Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexiwnSIJTzWwJ8VeM7APx_45Hk43dqhbbdk86_45lwUONdP6EMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addvO8qn8fVQ7pPk0DJ3HimZQu_W_45iZrQzZon_45MR32PeSQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesXEKean56H4ha_ERbTy7w5Rj6wuN3ZU9oAlY7Js6ONCIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editAXXHs5356xZSWma4PlnOpZGCA8xEBOtrZs1k8dJFwWYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursDhVpSthFOsvpxLOhSzRdqaBu7MIAr3u94dSNVNgSCGEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexlDwZv4a6XZn7A1E_yy4vMctM9jZLwuQQdZBgKh4_xoQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexOzD8XsxvH_45lzpDeBdcvXcW8GVRj5pwJ0nFJA_tORRdkMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexPiJnWbmmFII0Bj70Puxd2n0QE8kGdagWuYcrbo5S3P4Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/index.vue?macro=true";
import { default as indexEAdj4ad3Df006jPT6df95q957vri6BniJ9X346bNYNsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendrebBVKji45Epm5ipsCGwpulPctk5NpI7HEUcHnbiqLqNUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexFV_45SseDRqpVFpkKZ5Jh_450AnNOj7grBVPWYQqpDjd48kMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/index.vue?macro=true";
import { default as adduySLLODE8Em4ROEA8fHYuRuMj18fk85HUfdGnhSzbk8Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexDFjo0tX__POCaHn2x8ChZVD6_7__JGZr9TSqMPszTusMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editL6kMaSl_45E9eRKKWcB9IJ_45fDXZi9sfOj5_JeBWeaEL7AMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93mX81OEDTxQXK25MZCaOWHwIZqKrhG_451yLJo31lVFb0oMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteNwfnwsfK4SzW_45bKAcyRHxPY6zNFYtChgTqBiyJiLz1EMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexp44HUIF_45yJig6Ti7b_X09GJqeOx_W9j7fRxpByRM_4560Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participations6roI_FgSjE_dTjgarGROsB83mCfsUWcuCORNIQlAE9sMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/participations.vue?macro=true";
import { default as indexW8MwBUwhmOpdN31uwXFfa5zx4jHdIsxo0_NMGBgveycMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsknuSRhTEfUJBy2Z7Njoo2vQb4AoUUrimyrckIdg7WfoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/referents/activity-logs.vue?macro=true";
import { default as editMWBVS8qZM7pM5V3LJLz58qBz2p2UAqy_45SPc1JKcuSoYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexsRdb7DckEFrtP3hXg3KZuWUTwNEnrkt_45dXyrErLm93MMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsEWUNF2qAzAEXT53GpfXeJsomDbdHxCpG4jlD65_451hTUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesFZ1JvAYuakLTrvZLZmOihour0bUOHsJ7oth_451dFdfgsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editliDKPrf7da9u204m5mqhQwdh9X_q6Os0eAT7jQFaZOsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexohIA6JSbJOWJzC7wogsOXLXWh3BMcVdx6IRcAzplmBMMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexZnl4X32wG1m7myjTQHLQ3RBqDmai6liewIOWKZbuoocMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesbZ0NO_45Cr5nX4_45GqA2SQik3w4M_xh4C9NH46GZ_hbV4sMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editRzHR0WxitlsCS7l8sfYAGkVVJT_45lrm_45b17ZdKazwLvsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profile6ZLIRpLmWR5X32duGno525Qrw8zQf4uuUyv1K_LAYBMMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnement3nmlmh9yc2Nbt9D74cwcuuO_yPTAWzSvL4R8H6aPW2kMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsHY_h0PNEtSeHHO_00ROWuCcEBfGf9K381GSDqB3aYQoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editFGkAyamGKNzaciFRb57zTJNnFRFviQkVnmszGpSXG78Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addMxhSGPpSiwFMzmMPHoCoJmljYAdoZhQtcZjEWTRHYvQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationpXF7R1BuRt0XYePWyo4cu7JdAdkPBV50uMumTB1Ig94Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexWjMT96Vdu7spiJ1oxkSvuIZ3_M5Sshtd6X7FyPrvjjoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editiMuPvekB4Mgo6UC24veOfc6EchO3_45zv2EFQD_45VCNIg8Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionshJrLL_XABre29uOIpFgKmpf93nCXFSRSudUByL705NMMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationseKKsM04NMrk7OkvUqDyKopUJSx6DIgIIY1xfYveeAl4Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevoles8NUV0AskcxX5Z7uzep7uYCl7RCu9j1v262iM_Q4G0CAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexing6ksht3wQ6dr6pA9bW0_ESSFjYH9OLg7lDvMjx95mikQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as index_45wPS3vppShHwcTqjU6DDJYK7x8kryOoP4E_rclhmFE0Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editi0wfn4uxzq3_SojXZHfdDTKrlSJNsLHfY_45g6D8_bwlEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexZke3dFmM_09JeZSWKLLTpthI61SoFRYVLGvGa2sgZaoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileb8gjnXPiLLrYxKH2pH9ZrJpp3RqiVMmnoq6_pv8Z7U4Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexK7b3ZFyCZLeKjyQi8_45mfRSQ8Azb4m2t6IYoKAsBebdsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editeN__45eD_45Il_45Iu_Q8_JFbWGuWFIDXJz8PiLXwQuTOmc0gMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addODDvjwNG8qVRZvvcp1WtWz4oreRdkpMPwJ2g62MgpdUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesNETDgK8IxaEAMPGeSrJlh0sdOhashAK6hJ15Slg8SesMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferences8WepH79UGyd5qz7qweRqagokUI4_45nM6Gi695zoFOmbIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersQI89HDfwrWW1lRhxzx9HXYjXDyp8_45Ymb8JiQ9GGIYQoMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresss_k6bKeSw_45_tdcjX_45VeD2SAIXETUdGyT_3tP8sHYzgMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsables5JiPMZEFwrsf6mX3BkBVTXa2l5ghWPLNHRjAU5yhwpAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationVntcVOoB0FlTw_KQDnmlC8LHZ9Boh1p9u9Dk_S_45ks_cMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdateddaln8zyTFw6960qdYc320NqpSo9QYKLuGiR57ZqJGYQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsCryZu4IyowIvqWF_45EowNAKfJloiS3G7tc2UP2RziQxEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45role51u5DpaiHWHg6KxSABbUhGPgZusP7xbnlt28wRxElVkMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsxXA8jE05e1i_EzmNew2o8PLVH97pfOswGBdRE4_45_45DecMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editgmwnuIeDJ8AQAcgACLD_1as8inqp6drIxF0fHjJUKvQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibiliteszLX0taRgsULxQoCwd9Uk6gYZjNJzLCa8_enPp_Rt_3EMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkDCVfd0TiPxpFt7yR4krxRM_e7o4F3CXSLRpxqqN1WCEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexFEP6Wag8_45MaewTEZrbfkLdzaMd6zw6HoXkraYBpFVuwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectiviteUpBquErt3YvOBYC7K9QLbh5Q3fSEQ_KFDLGGtTwcKbIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationG7xBhTeG2O1vep86wk8jquuHYsFs8SfXR_45fztPoVPQUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsozL0Qh_pUyuXuoecZfeofDPwjLahdN79C8SqV_AppBEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantOe_Mvg06PmGmIOK9I3jk29PTg7Sfv_mGLKPPW_ndNzIMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantubqKqAe6HJLQetIhRh7GrILQhh5qqzotCVi_UtptpbAMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as index_P1QBhT5QbinbNmLczvM_4544EDGbAeYs0OUTx3Qh4IeEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimees0UI_45bAWpfzidNe3AXIH8RqaQaoyaXVGCOv8JMuidLP4Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerfIHaVl5M3VeGXGUNbTIMr7BCEkf7VOmfpua5SZyOjmwMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesCG6CCTVA2n7tMUayNTOSgyKlteD_45IZQdj_45onewm61SsMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesIWUM273K8MixnuNuoUkkOEOZnVwBBY5wQlW381M2cBQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsQ4zdNUzTGCNPwWCNSfV_cVwxvqv_45rV4erBpt0eZF3HQMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedTYnvSVYL76HAkxF8NUqursQNZunMFEd3_peqGlVjgCYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectnXFBDXsyIL3rLznNrVH0E_45g7ov8PBI9qfGHPYvHtkq8Meta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45valider9zNLGrFMi4n0rSwb4Y_45EP_IwYzRga4HlpuKC7EwTAIYMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementwpdwJjxy31eGbkqDDMQGabElAtA4x0CdaBD6cDaaYAMMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationAbftKzCn_oSDLTTmQygHduDRJnSr4i9ANDD9YPILr4gMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationoRh7Yon_45kC_452y7CjFNzGTQkhXSklMKDOTiDYm4mGMDEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerJhmDHjHeO78k2jFuvTLZ3V87aFjoC_45H5xQJhMLeo_45DUMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesGsKKbDb9f93C77VSY51HvF_6Ktqw4vVfZynwfE0OZQkMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME } from "/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginNiQnUUi32kog2_45rSlv6RRG17qcXBjgSHoHFT9ijUgvUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenws1gqIqjlr_453HHuN7NLbX0yENRN8ttHIJ_45UDoQXjQ5gMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexO3pIT9kk2ZbgXAF6xMyl6142zefiQV_9Ods3kbNC5MwMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesRjs7zKpO_UQNw5FHaE1JpQsoTUd73M_45KmKbez0VhUigMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexOzwLnIG4ZJ_451ashymhkoxa_rPQh7_45T7a20_45sbcXEj3sMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editCEriP5sUDOIVdmH90q7CxJ6vIizJMcQuPPUmDgmMGu0Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesLe8A482As8fn5uUjhUuizY74pi4zE47GdVMUkhsAsFsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93_RIjI_3B_45RArEnQ9MZZPj0UD2i_45Vxy2m_82gp5iw6n4Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationspJANcxSrA_45yGT90AYT6mSQuIchVwy9an47XRQXcdzfAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexBzkh6Z4IHWML32fgQdhkbT65VBNsNCnqgG6ZI7wqpzoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: index5UyrufiC_45RD4kQHBPGRpSH_45M6XJCteMHDkkhPdAUrKwMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexBO3OT0KLZZwYm26Boz2UxNQ9w560q77mUGrtPLqJ8aUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiquebEOiBqXJnIRYwdsl1ZDSGe1_45G_45bFIdd894K_Oy_NYGAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93pXz39zPancpfVVqK6dIFDMe6QetGzzSg1nkQOzyeO_UMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsJCEHVXxZ24aE1L00liSe6J46fKtt6QjH43CK2VKCc8AMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexiTx_c8p87Y5Ivo5WNptWA_45mZHhDi2UXYMdx6g8iBTmgMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisHtR7tIXHioIGSetHz2wCL7WyUgU_ry6bm8lcfoeRyaAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsfXLqCT6AgfQH5X3hB8BsT8kdHPiir6wgz0hCDZks8M8Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missions2kf1683lBg2VKb0SxSS3_i3WEIiBd8WG_s2bQBdLAxAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingswTtp5h8Vm1Y9CziEkwrhDZ7j5pAGYdxf1InfUUpmNdkMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/settings.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexONo3lZ6I4f4zjbw5JY9Pz11xza3RVmZATHkIo7w82hwMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminl5z7d_45jBvL7_M3j7n3rfSNugiIL19c8NvRjgd8_45f5qoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexiAdfVKYqSCaAYSCZ7kfRFhHD2ee51_45F6io0YeZsKnQsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93VyegDZ7nurlcJh1FV9HDqADKdIjS6HNpT5Ux3eubzM4Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursE8SgTHYZZ81OBePpPT6W56SB0Nzjgf1B2k8GdCBAgPYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferenceslG12dVraHHIatRweawwHdk4o0LlCNjjEzaJJqDPXgxoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsVTDwWKOCvPLpnksLsq_456_RxhD_45GS4WQnHe_451_45uy3U2oMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93twZPslVQ2c9WXRgf9klzL9APxzmK5_45ZsINfZ3z2SWnIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsRE3UIwN3hlvvHJ1W9WgTsBfqPQZYi0bHFHmNQYKD5QUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: index_45wk4BgrBgqkMWuw8PevfBvTAk4_45o0m9D54mPpEM0b5cMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addnyS9OkUIjIt93pX6elTDkKRNvZjwN_45JMCzktJmuJ5NUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93lo7spXAc_UgJHoUPC3P_CMda9YMKga7uKffZuHA_iFIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexoeeMDp7Xc9ym0l335lrSAkT9tPWGW2nnJkx50N__BpgMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participations5zO4t9VQKmV2QLzrCSB4Y3y_45Ihpsz6lVPCzQ8cL54IYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsz52aTFN3_bJrdl55qVqtnDovsEIl2s0cgN6EQdi96vAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexCU7EY0I5eqG36pBfskT8lKfxhZISkJkTKVIkPipzjnsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notifications9mbMmfPm8tTsmY64_5kk08ycr0T60mgEdTlGwVdix_IMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexyyVS5wwLTIvusgumKgrShRu9tLLxZ0NdU7_VoYf4Ei0Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexyHwJpxKB5GciFMbVWVez_458JvW6HDpYAaADYJ6xzyfJkMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93SXq35Qw09Uoo6ykX1Uhp2g_whfxyTfvV3cXqluZcEcEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleJfRJwBb70Bba7cUb4XRS25Fv6UR0BdWlzvK9xw_45j9xQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationshWr3lI3tdDIJ4hkPelcP50gUSTf3b00Iw0hBKZo0vlIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagescQdvu37G5bghdkULNwW4daAgK4KNWfkf0zsUhTAK6qYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesGi9STZIPh86yABxBbVAOKpRVU_451iLFb0KmB3wFZ7w40Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addyxAn9Q6UrzkXolZPivDpBbyqbDu2UoSOeZrcqH_HufAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexOMo8BHV4BilX2exQ2qkXJwjqx9UAdk0T0zASO4UDQZUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexrcx6UOcI6cIm7eFTIVrxH3qT6i_45_SzLcMMx8jzL00DIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: dates4w_6gqgVGL_45zB9BvEe1ccj_hs_45sc116Qbg8ZJoaq55MMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: index__AsYZvxWjccApYVsWTRX8alTteVBBj4a36Vge98094Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieux0dmHEc3lK4BAI3PT_6tCw9zwHBJJNJAvRQHh_53fPRoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleF52pV3wx05RTzvNZpqMKJCXQIrw_o9BNXkRqE0HqaIkMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexV6cb85zFnmBIYNhNbSnl4uh_45SvOFk9JfbxTHcSJ4uqgMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsqkcjNy5Ae9aZ6z360B4_45WStiChq1G9c8y3H_453hpmsmYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: add0I_g_XJS8XfnnngwzYu5E9Ay1xXsJGE0E29sF5J3rAAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelJuUuFC0jiRbp7_hY3aOD68QgiiK84msUOIwNoskHXxEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexIZfTBBHqx2O2BYtj0g3IWULuSjfeXBaqYJIfPi8XNfwMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: index9LXJW_KmovtSvygdzNRhRmPc9XsT6tihhL1CE6zPcqEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexRdcUjqosPHe8TYHQjDzV5p63ycwkVjfdwkl2xl70uJgMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addmwUDxlRQ6fwR1cCAEVAp79l6P_K90DBBWRESd2VESW4Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: add3LtBO2ij57s_obVzkTDqd_2_7ppk2DUWDAhnXX3sy5EMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addCjnN9c4j8Dus6r1NC1B4tVHvx60a8_45x5l8IXCUZs8twMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexR9Nx4pHGovhShX2d0RXwlVEyjA_djiraYEJNns1mJwwMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionslMKgmzXnjAH1wbfdMWZ5Dl_45GmgqjuAArAXtFJnIWpw0Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: edit1Tvja_45JOVpyf8rFCL4SK_457wHtKXRTRYLqkoTJKiC0noMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexiwnSIJTzWwJ8VeM7APx_45Hk43dqhbbdk86_45lwUONdP6EMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addvO8qn8fVQ7pPk0DJ3HimZQu_W_45iZrQzZon_45MR32PeSQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesXEKean56H4ha_ERbTy7w5Rj6wuN3ZU9oAlY7Js6ONCIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editAXXHs5356xZSWma4PlnOpZGCA8xEBOtrZs1k8dJFwWYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursDhVpSthFOsvpxLOhSzRdqaBu7MIAr3u94dSNVNgSCGEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexlDwZv4a6XZn7A1E_yy4vMctM9jZLwuQQdZBgKh4_xoQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexOzD8XsxvH_45lzpDeBdcvXcW8GVRj5pwJ0nFJA_tORRdkMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrebBVKji45Epm5ipsCGwpulPctk5NpI7HEUcHnbiqLqNUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexFV_45SseDRqpVFpkKZ5Jh_450AnNOj7grBVPWYQqpDjd48kMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: adduySLLODE8Em4ROEA8fHYuRuMj18fk85HUfdGnhSzbk8Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexDFjo0tX__POCaHn2x8ChZVD6_7__JGZr9TSqMPszTusMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editL6kMaSl_45E9eRKKWcB9IJ_45fDXZi9sfOj5_JeBWeaEL7AMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteNwfnwsfK4SzW_45bKAcyRHxPY6zNFYtChgTqBiyJiLz1EMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexp44HUIF_45yJig6Ti7b_X09GJqeOx_W9j7fRxpByRM_4560Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participations6roI_FgSjE_dTjgarGROsB83mCfsUWcuCORNIQlAE9sMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsknuSRhTEfUJBy2Z7Njoo2vQb4AoUUrimyrckIdg7WfoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editMWBVS8qZM7pM5V3LJLz58qBz2p2UAqy_45SPc1JKcuSoYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexsRdb7DckEFrtP3hXg3KZuWUTwNEnrkt_45dXyrErLm93MMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsEWUNF2qAzAEXT53GpfXeJsomDbdHxCpG4jlD65_451hTUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesFZ1JvAYuakLTrvZLZmOihour0bUOHsJ7oth_451dFdfgsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editliDKPrf7da9u204m5mqhQwdh9X_q6Os0eAT7jQFaZOsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexohIA6JSbJOWJzC7wogsOXLXWh3BMcVdx6IRcAzplmBMMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexZnl4X32wG1m7myjTQHLQ3RBqDmai6liewIOWKZbuoocMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesbZ0NO_45Cr5nX4_45GqA2SQik3w4M_xh4C9NH46GZ_hbV4sMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editRzHR0WxitlsCS7l8sfYAGkVVJT_45lrm_45b17ZdKazwLvsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profile6ZLIRpLmWR5X32duGno525Qrw8zQf4uuUyv1K_LAYBMMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsHY_h0PNEtSeHHO_00ROWuCcEBfGf9K381GSDqB3aYQoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editFGkAyamGKNzaciFRb57zTJNnFRFviQkVnmszGpSXG78Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addMxhSGPpSiwFMzmMPHoCoJmljYAdoZhQtcZjEWTRHYvQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexWjMT96Vdu7spiJ1oxkSvuIZ3_M5Sshtd6X7FyPrvjjoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editiMuPvekB4Mgo6UC24veOfc6EchO3_45zv2EFQD_45VCNIg8Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionshJrLL_XABre29uOIpFgKmpf93nCXFSRSudUByL705NMMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationseKKsM04NMrk7OkvUqDyKopUJSx6DIgIIY1xfYveeAl4Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexing6ksht3wQ6dr6pA9bW0_ESSFjYH9OLg7lDvMjx95mikQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: index_45wPS3vppShHwcTqjU6DDJYK7x8kryOoP4E_rclhmFE0Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editi0wfn4uxzq3_SojXZHfdDTKrlSJNsLHfY_45g6D8_bwlEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexZke3dFmM_09JeZSWKLLTpthI61SoFRYVLGvGa2sgZaoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileb8gjnXPiLLrYxKH2pH9ZrJpp3RqiVMmnoq6_pv8Z7U4Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexK7b3ZFyCZLeKjyQi8_45mfRSQ8Azb4m2t6IYoKAsBebdsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editeN__45eD_45Il_45Iu_Q8_JFbWGuWFIDXJz8PiLXwQuTOmc0gMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addODDvjwNG8qVRZvvcp1WtWz4oreRdkpMPwJ2g62MgpdUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesNETDgK8IxaEAMPGeSrJlh0sdOhashAK6hJ15Slg8SesMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferences8WepH79UGyd5qz7qweRqagokUI4_45nM6Gi695zoFOmbIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersQI89HDfwrWW1lRhxzx9HXYjXDyp8_45Ymb8JiQ9GGIYQoMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresss_k6bKeSw_45_tdcjX_45VeD2SAIXETUdGyT_3tP8sHYzgMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationVntcVOoB0FlTw_KQDnmlC8LHZ9Boh1p9u9Dk_S_45ks_cMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdateddaln8zyTFw6960qdYc320NqpSo9QYKLuGiR57ZqJGYQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsCryZu4IyowIvqWF_45EowNAKfJloiS3G7tc2UP2RziQxEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45role51u5DpaiHWHg6KxSABbUhGPgZusP7xbnlt28wRxElVkMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsxXA8jE05e1i_EzmNew2o8PLVH97pfOswGBdRE4_45_45DecMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editgmwnuIeDJ8AQAcgACLD_1as8inqp6drIxF0fHjJUKvQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibiliteszLX0taRgsULxQoCwd9Uk6gYZjNJzLCa8_enPp_Rt_3EMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkDCVfd0TiPxpFt7yR4krxRM_e7o4F3CXSLRpxqqN1WCEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexFEP6Wag8_45MaewTEZrbfkLdzaMd6zw6HoXkraYBpFVuwMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteUpBquErt3YvOBYC7K9QLbh5Q3fSEQ_KFDLGGtTwcKbIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationG7xBhTeG2O1vep86wk8jquuHYsFs8SfXR_45fztPoVPQUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsozL0Qh_pUyuXuoecZfeofDPwjLahdN79C8SqV_AppBEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantOe_Mvg06PmGmIOK9I3jk29PTg7Sfv_mGLKPPW_ndNzIMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantubqKqAe6HJLQetIhRh7GrILQhh5qqzotCVi_UtptpbAMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: index_P1QBhT5QbinbNmLczvM_4544EDGbAeYs0OUTx3Qh4IeEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimees0UI_45bAWpfzidNe3AXIH8RqaQaoyaXVGCOv8JMuidLP4Meta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerfIHaVl5M3VeGXGUNbTIMr7BCEkf7VOmfpua5SZyOjmwMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesCG6CCTVA2n7tMUayNTOSgyKlteD_45IZQdj_45onewm61SsMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesIWUM273K8MixnuNuoUkkOEOZnVwBBY5wQlW381M2cBQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsQ4zdNUzTGCNPwWCNSfV_cVwxvqv_45rV4erBpt0eZF3HQMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedTYnvSVYL76HAkxF8NUqursQNZunMFEd3_peqGlVjgCYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45valider9zNLGrFMi4n0rSwb4Y_45EP_IwYzRga4HlpuKC7EwTAIYMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationAbftKzCn_oSDLTTmQygHduDRJnSr4i9ANDD9YPILr4gMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationoRh7Yon_45kC_452y7CjFNzGTQkhXSklMKDOTiDYm4mGMDEMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerJhmDHjHeO78k2jFuvTLZ3V87aFjoC_45H5xQJhMLeo_45DUMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesGsKKbDb9f93C77VSY51HvF_6Ktqw4vVfZynwfE0OZQkMeta || {},
    component: () => import("/build/cd03cee4-90f2-4670-bed1-ac470305f6c4/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/user/settings",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/inscription/organisation",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/statistiques",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  },
  {
    name: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cMEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub3_457426UXj9G1b_45hXp_45S_0IJLLtJuhUVU4Hr8i6D7cME
  }
]